import * as React from "react";
import { ParentProps } from "../../../widgets/types";

import "./styles.scss";

export default function PageSection(props: ParentProps): React.JSX.Element {
  return <section className="scd-page-section">{props.children}</section>;
}
